/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const file_xml_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M13 23H2.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h10.036a1 1 0 0 1 .764.354l4.963 5.866a1 1 0 0 1 .237.646V9"
    />
    <path
      fill="#000"
      d="m11.6 19-2.02-3.6 1.93-3.4H9.86l-1.05 2.11L7.8 12H6.09l1.92 3.5L6 19h1.72l1.07-2.14L9.82 19h1.78Zm5.896-6.99h-1.78l-.74 3.41-.74-3.42h-1.74v7h1.37v-3.64l.52 2.21h1.21l.47-2.22v3.66h1.43v-7Zm2.996 5.79V12h-1.5v7h4.6v-1.2h-3.1Z"
    />
  </svg>
)
export default file_xml_medium
